
import {AuthToken} from '../../auth/model/auth-token.model';

export class User {

  public username: string;
  public password: string;
  public authToken: AuthToken;
  public permissions: object[];

  constructor(username: string = null, password: string = null, authToken: AuthToken = null, permissions: object[] = null) {
    this.username = username;
    this.password = password;
    this.authToken = authToken;
    this.permissions = permissions;
  }

}



// WEBPACK FOOTER //
// C:/Users/DENISE/Documents/IT4U/web-callcenter/src/app/shared/user/model/user.model.ts